export const NORMAL = 'normal';
export const MULTIPLY = 'multiply';
export const MASK = 'mask';
export const OVERLAY = 'overlay';
export const SCREEN = 'screen';

export const blendingModes = [NORMAL, MULTIPLY, MASK, OVERLAY, SCREEN] as const;
export type BlendingMode = (typeof blendingModes)[number];

export const documentModes = [
    { value: NORMAL, label: NORMAL },
    { value: MULTIPLY, label: MULTIPLY },
];

export const overlayModes = [
    { value: OVERLAY, label: OVERLAY },
    { value: SCREEN, label: SCREEN },
];

export const ENGRAVING_CHANNEL = 'Engraving';
export const LETTERPRESS_CHANNEL = 'Letterpress';
export const LETTERPRESS_TRANSFORM_ID = 'LetterpressTransform';
export const LETTERPRESS_MODE_SOFTLIGHT = 'softlight';
export const LETTERPRESS_MODE_OVERLAY = 'overlay';

export const EFFECT_TYPE_LIST = [
    { value: 'none', label: 'None' },
    { value: ENGRAVING_CHANNEL, label: 'Engraving' },
    { value: LETTERPRESS_CHANNEL, label: 'Letter Press' },
];

export const LETTERPRESS_FILTER = 'LetterpressFilter';
export const LETTERPRESS_MODES = [LETTERPRESS_MODE_SOFTLIGHT, LETTERPRESS_MODE_OVERLAY] as const;
export type LetterPressMode = (typeof LETTERPRESS_MODES)[number];

export const LETTERPRESS_MODES_OPTIONS = [
    { value: LETTERPRESS_MODE_SOFTLIGHT, label: 'Softlight' },
    { value: LETTERPRESS_MODE_OVERLAY, label: 'Overlay' },
];

export const LETTERPRESS_DEPTHS = [...Array(10).keys()].map((i) => ({ value: i + 1, label: `${i + 1}` }));
